import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-success',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-success.component.html',
  styleUrl: './alert-success.component.scss'
})
export class AlertSuccessComponent {
  isDisabled: boolean = false;
  @Input() Message: string = '';
  @Input() Message2: string = '';
  constructor(
    private activeModal: NgbActiveModal,
  ) {}

  close(result:boolean) {
    this.activeModal.close(result);
  }
}
